/**
 * Pre-compiled pt-BR messages for NumberInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { decrement: `Redução`, increment: `Aumento` };
